import { capacityEntryPoint } from '@jira/spa-apps__software-capacity-people/src/capacityEntryPoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareCapacityClassicPeopleEmbedRoute } from '@jira/router-routes__classic-projects-routes/src/softwareCapacityClassicPeopleEmbedRoute.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticSidebarShortcutsResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { CapacityEmbedSkeleton } from '@jira/platform__skeletons/src/ui/capacity/CapacitySkeleton.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const softwareCapacityPeopleEmbedRouteEntry = createPageEntryPoint({
	main: capacityEntryPoint,
});

export const softwareCapacityClassicPeopleEmbedRouteEntry: Route = createEntry(
	softwareCapacityClassicPeopleEmbedRoute,
	() => ({
		bifrost: {
			bifrostGroup: 'shell-only',
		},
		// eslint-disable-next-line no-restricted-syntax
		component: CapacityEmbedSkeleton,
		entryPoint() {
			if (__SERVER__) {
				return undefined;
			}
			return softwareCapacityPeopleEmbedRouteEntry;
		},
		group: 'classic-software',
		layout: chromelessLayout,
		resources: [
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticSidebarShortcutsResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...jiraSpaResources(),
		],
		skeleton: CapacityEmbedSkeleton,
		ufoName: 'classic-capacity-people-embed',
	}),
);
